import ChatComponent from './chatComponent';

export default ChatComponent